var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ListSectionValueEditor',{staticClass:"ListSectionValueEditor__RelatedDoc",attrs:{"index":_vm.index,"content":_vm.linkHtml,"isInvalidContent":_vm.isInvalidDocLink,"listType":"ul","showEdit":false,"editable":!_vm.notEditable},on:{"delete":_vm.deleteMe,"edit":_vm.openEditForm}})
}
var staticRenderFns = []

export { render, staticRenderFns }